.dialog-content {
  padding-top: 5px;
}
